module.exports = "pegasus/assets/tech/realty/101.png";